import React, { useEffect } from "react";
import { Modal } from "../../components/modal";
import { CardPanel, Container } from "./style";
import {
  ManagerPettyCashAction,
  PettyCashierSelectionModalAction
} from "../../actions";
import { connect } from "react-redux";
import getUserIdentification from "../../assets/getUserIdentification";
import {
  PROJECT_USER_ROLES,
  PROJECT_USER_STATE
} from "../../constants/projectUser";

const Index = props => {
  const { modalData, modalStatus, closeModal, list, loading } = props;

  useEffect(() => {
    if (modalStatus) {
      props.getPettyCashierList({
        user_types: [PROJECT_USER_ROLES.CUSTODIAN],
        states: [PROJECT_USER_STATE.ACTIVE, PROJECT_USER_STATE.INACTIVE]
      });
    }
  }, [modalData]);

  if (modalStatus) {
    return (
      <Modal
        header={{ title: `انتخاب تنخواه‌دار` }}
        show={modalStatus}
        closeHandler={closeModal}
        height={"70vh"}
        body={
          <Container>
            {list &&
              list.map(projectUser => {
                return (
                  <CardPanel
                    key={projectUser.id}
                    onClick={() => modalData.onClick(projectUser, modalData)}
                  >
                    <div className="top-row">
                      <i className={`role-icon icon mapsa-pettycasher`} />
                      <div className="user-team">
                        <span>{getUserIdentification(projectUser.user)}</span>
                        {projectUser.team && (
                          <span>
                            {projectUser.team.is_default
                              ? ""
                              : projectUser.team.name}
                          </span>
                        )}
                      </div>
                    </div>
                  </CardPanel>
                );
              })}
          </Container>
        }
        loading={loading}
      />
    );
  } else {
    return null;
  }
};

const mapStateToProps = store => {
  return {
    modalData: store.PettyCashierSelection.modalData,
    modalStatus: store.PettyCashierSelection.modalStatus,
    list: store.ManagerPettyCash.userList,
    loading: store.ManagerPettyCash.userListLoading,
    error: store.ManagerPettyCash.userListError
  };
};
const mapDispatchToProps = dispatch => {
  return {
    closeModal: () => {
      dispatch(PettyCashierSelectionModalAction.closeModal());
    },
    getPettyCashierList: filter => {
      dispatch(ManagerPettyCashAction.getUsersListRequest(filter));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Index);
